var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{class:['status-badge', _vm.resolvedClass, _vm.customClass],style:(_vm.customStyle),attrs:{"variant":_vm.resolvedVariant,"pill":_vm.pill}},[_vm._v(" "+_vm._s(_vm.resolvedLabel)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }